import React, { useState } from 'react';
import './XR.css';
import Navbar from '../components/Navbar';

const VirtualWalkthrough = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <Navbar />
      <div className="xr-container">
        <div className="xr-content">
          <p className="page-path">Services / Immersive Walk-throughs & Simulations</p>
          <h5 className="xr-title">Immersive Walk-throughs & Simulations</h5>
          <p className="subtitle">
            Bring environments to life with interactive spatial experiences
          </p>
          <p className="description">
            Enhance spatial awareness and decision-making through 360° or VR-based simulations
            for plant tours, industrial processes, and orientation programs.
            <span className="know-toggle" onClick={() => setShowMore(!showMore)}>
              {showMore ? ' Know less' : ' Know more...'}
            </span>
          </p>

          {/* {showMore && (
            <p className="extra-text">
              These immersive experiences are designed to simulate real-world environments,
              helping users to familiarize themselves with complex workflows or safety protocols
              before encountering them in reality. Whether used for training, marketing,
              or exploration, these simulations increase engagement and improve learning outcomes.
            </p>
          )} */}

          <div className="xr-highlights">
            <h6>Highlights:</h6>
            <ul>
              <li>
                Hybrid models combining real-world video, 3D scans, and interactive hotspots.
              </li>
              <li>
                Ideal for onboarding, marketing, safety walkthroughs, and operational training.
              </li>
            </ul>
          </div>
        </div>

        <div className="xr-image-wrapper">
          <img
            src="../images/page1image7.webp"
            alt="XR Workshop"
            className="xr-image"
          />
        </div>
      </div>
    </>
  );
};

export default VirtualWalkthrough;
